(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('[data-faq-item]');
      this.#init();
    }

    #init() {
      for (const item of this.items) {
        item.addEventListener('toggle', this.#handleToggle.bind(this));
      }
    }

    #handleToggle(event) {
      const currentItem = event.target;

      if (currentItem.open) {
        for (const item of this.items) {
          if (item !== currentItem && item.open) {
            item.removeAttribute('open');
          }
        }
      }
    }
  }

  customElements.define('faq-accordion', FaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-marquee"] && !Shopify.designMode) return;
  try {
    
  class InstagramMarquee extends HTMLElement {
    constructor() {
      super();
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    connectedCallback() {
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
    }

    handleMouseEnter() {
      this.classList.add('paused');
    }

    handleMouseLeave() {
      this.classList.remove('paused');
    }
  }

  if (!customElements.get('instagram-marquee')) {
    customElements.define('instagram-marquee', InstagramMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories"] && !Shopify.designMode) return;
  try {
    
  class VideoModalComponent extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('.video-modal');
      this.closeButton = this.querySelector('.video-modal__close');
      this.content = this.querySelector('.video-modal__content');
      this.currentVideoElement = null;

      this.#bindEvents();
    }

    #bindEvents() {
      const videoCards = document.querySelectorAll('.video-stories__card');

      for (const card of videoCards) {
        card.addEventListener('click', () => this.#openVideo(card));
      }

      this.closeButton?.addEventListener('click', () => this.#closeVideo());
      this.dialog?.addEventListener('click', (e) => {
        if (e.target === this.dialog) {
          this.#closeVideo();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.dialog?.open) {
          this.#closeVideo();
        }
      });
    }

    #openVideo(card) {
      const videoUrl = card.dataset.videoUrl;
      const videoType = card.dataset.videoType;

      if (!videoUrl) return;

      this.content.innerHTML = '';

      if (videoType === 'youtube') {
        const videoId = this.#getYouTubeVideoId(videoUrl);

        if (videoId) {
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          this.content.appendChild(iframe);
          this.currentVideoElement = iframe;
        }
      } else {
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        this.content.appendChild(video);
        this.currentVideoElement = video;
      }

      this.dialog?.showModal();
      document.body.style.overflow = 'hidden';
    }

    #closeVideo() {
      if (this.currentVideoElement) {
        if (this.currentVideoElement.tagName === 'VIDEO') {
          this.currentVideoElement.pause();
        }
        this.currentVideoElement = null;
      }

      this.content.innerHTML = '';
      this.dialog?.close();
      document.body.style.overflow = '';
    }

    #getYouTubeVideoId(url) {
      const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/,
        /youtube\.com\/embed\/([^&\s]+)/,
        /youtube\.com\/v\/([^&\s]+)/
      ];

      for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match) return match[1];
      }

      return null;
    }
  }

  customElements.define('video-modal-component', VideoModalComponent);

  } catch(e) { console.error(e); }
})();
})();
